<template>
  <div>
    <form  @submit.prevent="submit">
      <div class="row justify-content-center">
        <div class="col-sm-9 p-2" style="font-size:12px;">
          <div class="shadow p-3 rounded-lg">
          <!-- INPUT -->
          <div class="sm-form">
            <input
              type="text"
              id="id"
              name="id"
              class="form-control form-control-sm"
              placeholder="id"
              v-model="vdata.id"
              disabled
            />
          </div>
        Untuk mendapatkan gradient Color Kunjungi > <span class="text-red-400 font-semibold text-xs"><a href="https://cssgradient.io/" target="__blank">https://cssgradient.io/</a></span>
        <div class="row">
          <div class="col-6">
              <div class="sm-form ">
                  <label for="button_color">button_color</label>
                  <input type="text" id="button_color" name="button_color" class="form-control form-control-sm" placeholder="button_color" v-model="vdata.button_color" >
              </div>
              <div class="sm-form ">
                  <label for="font_color">font_color</label>
                  <input type="color" id="font_color" name="font_color" class="form-control form-control-sm" placeholder="font_color" v-model="vdata.font_color" >
              </div>
              <div class="sm-form ">
                  <label for="background_color">background_color</label>
                  <input type="text" id="background_color" name="background_color" class="form-control form-control-sm" placeholder="ambil color nya di : https://cssgradient.io/" v-model="vdata.background_color" >
              </div>
              <div class="sm-form ">
                  <label for="background_card">background_card Kiri (untuk layout type 3,4)</label>
                  <input type="text" id="background_card" name="background_card" class="form-control form-control-sm" placeholder="ambil color nya di : https://cssgradient.io/" v-model="vdata.background_card" >
              </div>
              <div class="sm-form ">
                  <label for="background_card2">background_card Kanan</label>
                  <input type="text" id="background_card2" name="background_card2" class="form-control form-control-sm" placeholder="ambil color nya di : https://cssgradient.io/" v-model="vdata.background_card2" >
              </div>
          </div>
          <div class="col-6">
            <p>Layout type</p>
            <select class='form-control' v-model="vdata.typelayout">
              <option>1</option>
              <option>2</option>
              <option>3</option>
              <option>4</option>
              <option>5</option>
            </select>
            <div v-if="vdata.typelayout=='3'||vdata.typelayout=='4'">
            <p>Main Photo type</p>
            <select class='form-control' v-model="vdata.photo">
              <option >lingkaran</option>
              <option >kotak</option>
            </select>
            </div>
            <p>Skill view type</p>
            <select class='form-control' v-model="vdata.skilltype">
              <option>1</option>
              <option>2</option>
            </select>
            <p>Particle</p>
            <select class='form-control' v-model="vdata.particle">
            <option >particle1</option>
            <option >particle2</option>
            <option >particle3</option>
            <option >particle4</option>
            <option >particle5</option>
            <option >particle6</option>
            </select>
            <div class="sm-form ">
                <label for="particle_point">particle_point</label>
                <input type="color" id="particle_point" name="particle_point" class="form-control form-control-sm" placeholder="particle_point" v-model="vdata.particle_point" >
            </div>
              <div class="sm-form ">
                <label for="particle_line">particle_line</label>
                <input type="color" id="particle_line" name="particle_line" class="form-control form-control-sm" placeholder="particle_line" v-model="vdata.particle_line" >
            </div>
          </div>
        </div>
        <!-- <div class="sm-form ">
            <label for="linkcv">CV link</label>
            <input type="text" id="linkcv" name="linkcv" class="form-control form-control-sm" placeholder="linkcv" v-model="vdata.linkcv" >
        </div> -->
          <!-- END INPUT -->
          <!-- BUTTON PART -->
          <div class="mt-3 p-3">
            <button
              type="submit"
              class="btn btn-sm"
              :class="
                btn == 'tambah'
                  ? 'btn-primary'
                  : btn == 'update'
                  ? 'btn-success'
                  : 'btn-danger'
              "
            >
              <span class="typcn typcn-info"></span> Proses  {{ btn }}
            </button>
            <div class="float-right">
              <button
                type="button"
                v-show="btn!='tambah'"
                @click="
                  btn = 'tambah';
                  vdata = {};
                "
                class="btn btn-sm btn-dark"
              >
                <span class="typcn typcn-edit"></span> Tambah
              </button>
              <button
                type="button"
                @click="btn = 'delete'"
                v-show="btn!='tambah'"
                class="ml-3 btn btn-sm btn-danger"
              >
                <span class="typcn typcn-delete"></span> Delete
              </button>
            </div>
          </div>
          </div>
          <!-- END BUTTON PART -->
        </div>
        <div class="col-sm-9 p-2" style="font-size:12px;">
          <div class="shadow rounded-lg">
            <!-- TABLE PART -->
            <div v-if="datanya.length>0" class="p-2">
             <div class="text-right">
                <vue-json-excel :data="datanya">
                  <button type="button" class="btn btn-sm btn-dark">
                    Export <span class="typcn typcn-chart-area"></span>
                  </button>
                </vue-json-excel>
              </div>
                <Btables :tables="datanya"  :cari="['']" :hide="['']" @selected="ambil" ref="btable" />
            </div>
            <!-- END TABLE PART -->
         </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
// TOTURIAL 
// ganti source autophp, ganti source component btable, ganti path table sdb
import autophp from "@/plugins/autophp.js"; // ganti source nya
import Btables from "@/components/Btables.vue"; //component btable nya
let sdb = new autophp();
let urlnya ='https://gis.officialapp.my.id'
export default {
  components: {
    Btables,
  },
  data() {
    return {
      selected: false,
      vdata: {},
      btn: "tambah",
      datanya:[],
    };
  },
    layout:'app_admin',
  methods: {
    upload(){
        let file = document.querySelector("#filenya"); // berikan id pada input file
        sdb.collection('tbuser',false,urlnya).upload(file,true,true) // file,compress,scramble
        .then(res=>{
            console.log(res)
            this.vdata.gambar=res;
            this.$forceUpdate();
        })
    },
    getData(){
      sdb.collection("app_portofolio_layout",false,urlnya).doc().select(`select * from app_portofolio_layout where iduser='${this.$store.state.users.id}'`).then(res => {
         if(res.length>0){
          this.vdata=res[0]
          this.btn='update'
        }
        this.datanya=res;
        this.$forceUpdate();
      });
    },
    ambil(data) {
      this.vdata = data;
      this.btn = "update";
      this.$forceUpdate();
    },
    async submit() {
      let that=this
      that.vdata.iduser=this.$store.state.users.id
      if (confirm("Apakah yakin proses dilanjutkan ?")) {
        if (this.btn == "tambah") {
          delete this.vdata.id;
          await sdb
            .collection("app_portofolio_layout",true,urlnya)
            .doc()
            .set(this.vdata)
              that.getData();
        } else if (this.btn == "update") {
         await sdb
            .collection("app_portofolio_layout",true,urlnya)
            .doc()
            .set(this.vdata)
              that.getData();
        } else if (this.btn == "delete") {
          await sdb
            .collection("app_portofolio_layout",true,urlnya)
            .doc(this.vdata.id)
            .delete()
              that.getData();
        }
      }
    },
  },
  async mounted() {
          this.getData();
  },
};
</script>